interface String {
    stringToDate(): Date | null;
    CompareDateString(toDateStr?: string): boolean;
    formatMoney(thousandSeparator?: string): string;
    jsonTo<T>(): T;
    stringDateTimeToString(): string;
    stringToBinary(): string;
    binaryToString(): string;
    parseMoneyToDecimal(thousandSeparator: string): number;
}

String.prototype.stringToDate = function (): Date | null {
    const str = this;

    if (str == null || str == "") return null;
    var reggie = /(\d{1,2})\/(\d{1,2})\/(\d{4})/;
    var dateArray = reggie.exec(str as string);
    if (dateArray == null) return null;

    var dateObject = new Date(
        (+dateArray[3]),
        (+dateArray[2]) - 1, // Careful, month starts at 0!
        (+dateArray[1])
    );
    return dateObject;
}

String.prototype.CompareDateString = function (toDateStr?: string): boolean {
    const str = this;
    if (!!str && !!toDateStr) {
        const fromDate = str.stringToDate();
        const toDate = toDateStr.stringToDate();
        if (!!fromDate) {
            return fromDate.CompareDate(toDate);
        }
    }
    return true;
}

String.prototype.formatMoney = function (thousandSeparator?: string): string {
    try {
        const str = this;
        if (!str) return "";
        const num = parseInt(str as string);
        if (thousandSeparator == ',')
            return num.formatMoney(',');
        else
            return num.formatMoney('.');
    } catch {
        return "";
    }
}

String.prototype.jsonTo = function <T>(): T {
    return JSON.parse(this as string) as T;
}

String.prototype.stringDateTimeToString = function (): string {
    try {
        const str = this;
        if (!str) return "";
        const date = new Date(str as string);
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    } catch {
        return "";
    }
}

String.prototype.stringToBinary = function () {
    //for BINARY maxBytes = 255
    let str = this;
    const maxBytes = 65535
    let binaryOutput = '';
    if (str.length > maxBytes) {
        str = str.substring(0, maxBytes);
    }

    for (var i = 0; i < str.length; i++) {
        binaryOutput += str[i].charCodeAt(0).toString(2) + ' ';
    }

    return binaryOutput;
};

String.prototype.binaryToString = function () {
    const str = this;
    const arrayOfBytes = str.split(' ');
    let stringOutput = '';

    for (let i = 0; i < arrayOfBytes.length; i++) {
        stringOutput += String.fromCharCode(parseInt(arrayOfBytes[i], 2));
    }

    return stringOutput;
};

String.prototype.parseMoneyToDecimal = function (thousandSeparator: string): number {
    let numStr = this;
    if (thousandSeparator == '.')
        return parseFloat(numStr.replace(/\./g, "").replace(/\,/g, "."));
    else
        return parseFloat(numStr.replace(/\,/g, ""));
};